import React, { useMemo } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@mui/material';
import useNewCampaignSchedule from 'c-main/Components/Schedule/useNewCampaignSchedule';

import { useCommonTranslation } from 'c-translation';

type Props = {
    id: number | string;
};

const ownerName = (owner: any): string => (typeof owner === 'string' ? owner : owner?.name ?? '');

const scheduleNames = (schedules: any): string =>
    Array.isArray(schedules)
        ? schedules.map(s => (typeof s === 'string' ? s : s?.name ?? '')).join(', ')
        : '';

const SelectedItemsTable: React.FC<Props> = ({ id }) => {
    const {
        selected,
        setSelected,
        selectedScreens,
        setSelectedScreens,
        selectedDisplays,
        setSelectedDisplays,
        popDisplaysSelected,
        popDisplaysList,
        setPopDisplaysSelected,
    } = useNewCampaignSchedule(id);

    const handleRemove = (id: number | string) => {
        setSelected(prevItems => prevItems.filter(item => item.id !== id));
        setSelectedScreens(prevItems => prevItems.filter(item => item.id !== id));
        setSelectedDisplays(prevItems => prevItems.filter(item => item.id !== id));
        setPopDisplaysSelected(prevItems => prevItems.filter(item => item.id !== id));
    };
    const allSelected = useMemo(() => {
        const popDisplayRows = popDisplaysSelected.map(pop => {
            const full = popDisplaysList.find(d => d.id === pop.id);
            return {
                ...pop,
                screenIds: full?.screen_ids ?? [],
                schedules: full?.schedules?.map(s => s.name) ?? [],
            };
        });

        return selected
            .concat(selectedScreens)
            .concat(
                selectedDisplays.map(item => ({
                    ...item,
                    schedules: (item.schedules ?? []).map(s => s.name),
                })),
            )
            .concat(popDisplayRows);
    }, [selected, selectedScreens, selectedDisplays, popDisplaysSelected, popDisplaysList]);
    const t = useCommonTranslation();

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.idCol')}
                        </TableCell>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.nameCol')}
                        </TableCell>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.frameIdCol')}
                        </TableCell>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.ownerCol')}
                        </TableCell>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.scheduleCol')}
                        </TableCell>
                        <TableCell>
                            {t('Modules.Main.Campaigns.CampaignSchedule.table.actionsCol')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {allSelected.map(item => (
                        <TableRow key={item.id}>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>
                                {(item as any).screenIds
                                    ? (item as any).screenIds.join(', ')
                                    : item.frameId ?? 'N/A'}
                            </TableCell>
                            <TableCell>{ownerName(item.owner)}</TableCell>
                            <TableCell>{scheduleNames(item?.schedules)}</TableCell>
                            <TableCell>
                                <Button
                                    variant="text"
                                    color="secondary"
                                    onClick={() => handleRemove(item.id)}
                                >
                                    Remove
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SelectedItemsTable;
